/**
 * Meta Pixel (Facebook) event helpers. The base pixel is loaded in
 * public/index.html (dataset 991653413973228), which fires the initial
 * PageView; everything else goes through these wrappers so a blocked or
 * missing fbq never breaks the app.
 */
export const trackMetaPixelEvent = (eventName: string, params?: { [key: string]: any }) => {
    const { fbq } = window as any;
    if (typeof fbq !== 'function') {
        return;
    }
    if (params) {
        fbq('track', eventName, params);
    } else {
        fbq('track', eventName);
    }
};

export const trackMetaPixelPageView = () => {
    trackMetaPixelEvent('PageView');
};
